import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClickPayment(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change(['payment'])
      return
    }

    if (current.includes('payment')) {
      let newSelected = current.filter(item => item !== 'payment')
      change(newSelected)
    } else {
      change([...current, 'payment'])
    }
  }
}

export function getCount(transactions, type) {
  return transactions.filter(item => item.type === type).length
}
